import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { useRenderComponentsContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { ButtonItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

const Buttons: RenderComponent = () => <div />; // never used

const Render = ({
  children,
  item,
}: RenderProps<DocumentItem<ButtonItemAttributes>>) => {
  const { components } = useRenderComponentsContext();
  const { Wrapper } = components;

  if (!item || !item?.children) {
    return null;
  }

  const { attributes } = item;

  if (!attributes || attributes?.hidden) {
    return null;
  }

  return <Wrapper.Render item={item}>{children}</Wrapper.Render>;
};

Buttons.componentName = 'Buttons';
Buttons.Render = Render;

export default Buttons;
